import { createSlice } from '@reduxjs/toolkit';

import { UploadManagementState } from './types';

export const initialState: UploadManagementState = {
  videoList: {} as UploadManagementState['videoList'],
  loading: false,
  error: '',
  forms: []
};

const localeSlice = createSlice({
  name: 'uploadManagement',
  initialState,
  reducers: {
    fetchVideoList: (state, action) => {
      state.loading = true;
      state.error = '';
      state.videoList = {} as UploadManagementState['videoList'];
    },
    fetchVideoListSuccess: (state, action) => {
      state.loading = false;
      state.videoList = action.payload;
    },
    fetchVideoListFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    postUpload: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    postUploadSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    postUploadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateUpload: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    updateUploadSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    updateUploadFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    postModeration: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    postModerationSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    postModerationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    putReview: (state, action) => {
      state.loading = true;
      state.error = '';
    },
    putReviewSuccess: state => {
      state.loading = false;
      state.error = '';
    },
    putReviewFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchForms: (state, action) => {
      // state.loading = true;
      state.error = '';
    },
    fetchFormsSuccess: (state, action) => {
      // state.loading = false;
      state.forms = action.payload;
    },
    fetchFormsFailure: (state, action) => {
      // state.loading = false;
      state.error = action.payload;
    },
    resetState: () => {
      return initialState;
    }
  }
});

export const {
  fetchVideoList,
  fetchVideoListSuccess,
  fetchVideoListFailure,
  postUpload,
  postUploadSuccess,
  postUploadFailure,
  postModeration,
  postModerationSuccess,
  postModerationFailure,
  putReview,
  putReviewSuccess,
  putReviewFailure,
  updateUpload,
  updateUploadSuccess,
  updateUploadFailure,
  fetchForms,
  fetchFormsSuccess,
  fetchFormsFailure,
  resetState
} = localeSlice.actions;

export default localeSlice.reducer;
